import { graphql } from 'react-relay';

export const aboTableFragment = graphql`
    fragment AboTable_table on SubscriptionTable {
        ...AboHeader_header
        documentheaders {
            all
            kid
            factsheet
            publications
            rb
            hjb
            taxtreat
            fpp
            info
            prospect
            generalpublications
        }
        entries {
            id
            fundsname
            isin
            category
            currency
            salesadmission
            distribution
            institutional
            traits
            documents {
                all
                kid
                factsheet
                publications
                rb
                hjb
                taxtreat
                fpp
                info
                prospect
                generalpublications
            }
        }
        documentlabels {
            labels {
                key
            }
            documentLabelsTitle
            ...OtherDocuments_documentLabels
        }
        livefilter {
            ...LiveFilter_liveFilter
        }
        detailfilter {
            ...DetailFilter_detailFilter
        }
        subscriptionfilter {
            ...DetailFilter_detailFilter
        }
        languagepreference {
            currentselection
            ...LanguagePreference_component
        }
        filterbuttontext
        filterbuttontextexpanded
        noResultsMessage
    }
`;
